import { IncidentAttributeId } from '@collector/sportsapi-client-legacy'
import { Incident } from '@collector/sportsapi-types'
import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'

import { IncidentDetailsFillState } from '../../enums'
import {
  DetailConfiguration,
  getAttributeId,
  isDetailButtonsConfiguration,
} from '../composables/useSportOptions'

export function hasIncidentSomeAttribute<T extends IncidentAttributeId>(
  incident: Incident | ProbableIncident,
  attributes: T[],
): boolean {
  return attributes.some((attribute) =>
    incident.attribute_ids?.includes(getAttributeId(attribute)),
  )
}

export function getIncidentAttributesDetailsFillState<
  T extends IncidentAttributeId,
>(
  groups: Map<unknown, DetailConfiguration<T>>,
  incident: ProbableIncident,
): IncidentDetailsFillState {
  const fulfilledGroups = []
  const importantGroups = Array.from(groups.values()).filter((g) => g.important)

  importantGroups.forEach((group) => {
    if (group.fulfilledWhen) {
      const attributes = incident.attribute_ids as T[]
      if (group.fulfilledWhen(attributes, incident)) {
        fulfilledGroups.push(group.name)
      }
      return
    }

    if (
      isDetailButtonsConfiguration(group) &&
      hasIncidentSomeAttribute(incident, group.attributes.map(getAttributeId))
    ) {
      fulfilledGroups.push(group.name)
      return
    }
  })

  if (fulfilledGroups.length === importantGroups.length) {
    return IncidentDetailsFillState.Filled
  }

  if (fulfilledGroups.length > 0) {
    return IncidentDetailsFillState.HalfFilled
  }

  return IncidentDetailsFillState.NotFilled
}
